export default {
  english: {
    label: 'Share on Linkedin',
  },
  french: {
    label: 'Partager sur Linkedin',
  },
  arabic: {
    label: 'انشر على Linkedin',
  },
  hebrew: {
    label: 'שתף בLinkdin',
  },
  persian: {
    label: 'در لینکدین به اشتراک بگذارید',
  },
}
